export enum UserRoleOfProvinceGulidRoom {
    ProvinceGuildRoomManager = 2 ,
    ProvinceSecretariat = 13,
    ProvinceTreasurer = 14,
    ProvinceGuildRoomViceManager = 1006,
    ProvinceGuildRoomExecutiveManager = 1007,
}
